import { useQuery } from "react-query";
import { useIvideon } from "./useIvideon";

export const useGetIvideonTariffs = () => {
  const { getTariffs } = useIvideon();

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["getTariffs"],
    queryFn: () => getTariffs(),
  });
  return { data: data?.data, isLoading, isError, refetch };
};
